const auxReact = props => props.children;

export default auxReact;
